import { render } from "./ListOperationsPage.vue?vue&type=template&id=05cf85d3&ts=true"
import script from "./ListOperationsPage.vue?vue&type=script&lang=ts"
export * from "./ListOperationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__